
import { FC } from "react";
import "../../components/OrderTracking/styles.scss";
import OrderDetailComp from "../../components/OrderTracking/OrderTrackingDetail";

const OrderDetailPage: FC = () => {
  return <OrderDetailComp />
};

export default OrderDetailPage;
